import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';

/**
 * Navigation component used to display nav bar with menu options
 */
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, MatTooltipModule, MatButtonModule, MatIconModule]
})
export class NavigationComponent {
  protected readonly collapsed = signal(true);

  protected toggle(): void {
    this.collapsed.update(value => !value);
  }
}
